import { useQuery } from '@tanstack/react-query';
import { useAuth, workspaceService, WorkspaceMember } from '@aaas/shared';

interface UseWorkspaceMembersOptions {
  excludeOwner?: boolean;
}

export function useWorkspaceMembers(
  workspaceId: string | undefined,
  options?: UseWorkspaceMembersOptions
) {
  const { user } = useAuth();
  const excludeOwner = options?.excludeOwner ?? false;

  return useQuery({
    queryKey: ['workspace-members', workspaceId, excludeOwner],
    queryFn: async (): Promise<WorkspaceMember[]> => {
      if (!workspaceId || !user) {
        throw new Error('Workspace ID and user required');
      }
      const idToken = await user.getIdToken();
      return workspaceService.getWorkspaceMembers(workspaceId, idToken, excludeOwner);
    },
    enabled: !!workspaceId && !!user,
  });
}
